// Module
var code = "<div ng-if=\"$ctrl.show\"> <span ng-repeat=\"chk in $ctrl.item.value\"> <p> <input type=\"checkbox\" class=\"filled-in\" ng-checked=\"chk.value == 'true'\" disabled=\"disabled\"/> <label>{{chk.key}}</label> </p> </span> </div> ";
// Exports
export default code;